module.exports = __webpack_public_path__ + "img/weldingfumes_icon.fa542076.svg";